import React from 'react'
import Profiling from './Profiling'

const VerifiedProfiling = () => {

    return (
        <>
         <Profiling type="verified"/>
        </>
    )
}

export default VerifiedProfiling